import { FaIcon, NonIdealState } from '@acp/core-ui';
import {
    Button, HStack, ModalBody, Text, VStack,
} from '@chakra-ui/react';
import {
    faPhone, faExclamationCircle, faAt,
} from '@fortawesome/pro-light-svg-icons';
import { AccessIssuesWizardMachineContext } from '../machine/context';
import { AccessIssuesWizardHeader } from '../components/wizard-header';

export function AccessIssuesWizardAllMethodsDisqualifiedScreen() {
    const machine = AccessIssuesWizardMachineContext.useActorRef();

    return (
        <ModalBody as={VStack} py={6} alignItems="stretch" gap={8}>
            <AccessIssuesWizardHeader showLockIcon showCloseIcon={false} />
            <VStack minH="96" justifyContent="center" py={12}>
                <NonIdealState
                    iconComponent={<FaIcon w={12} h={12} icon={faExclamationCircle} color="danger.500" />}
                    title="Please contact Detector Inspector"
                    description="Due to the complexity of the Access Issues facing this property, we'll need to connect you with a specialist in our Help team. Please contact them using the details below and quote the property address."
                    titleFontSize="lg"
                >
                    <VStack gap={4}>
                        <VStack gap={1}>
                            <Text fontSize="small">
                                <FaIcon icon={faPhone} mr={1} />
                                1300 134 563
                            </Text>
                            <Text fontSize="small">
                                <FaIcon icon={faAt} mr={1} />
                                help@detectorinspector.com.au
                            </Text>
                        </VStack>
                        <HStack>
                            <Button
                                colorScheme="blackAlpha"
                                bgColor="black"
                                size="md"
                                onClick={() => machine.send({ type: 'CLOSE_MODAL' })}
                            >
                                Close
                            </Button>
                        </HStack>
                    </VStack>
                </NonIdealState>
            </VStack>
        </ModalBody>
    );
}
